module.exports = __webpack_public_path__ + "static/media/logo_vietbank.ce44f985.svg";